t = require('app/scripts/views/internal/teacup-with-helpers')('header_warning_banner')

module.exports = ->
  t.ul ->
    t.li '.u-inline', ->
      t.mustacheBlock 'isAaMastered', ->
        # Message changes for day before users are forced logged out
        if (t.mustacheVar('daysLeft') == 1)
          t.format 'to-avoid-being-logged-out-please-confirm-your-email-by-tomorrow'
        # Aa mastered users have 14 days to confirm their account before
        # they are forced logged out
        else if (t.mustacheVar('daysLeft') <= 100)
          t.format 'please-confirm-your-email-in-the-next-x-days', { days: t.mustacheVar('daysLeft') }
      t.mustacheBlockInverted 'isAaMastered', ->
        t.format 'please-confirm-your-email-address-email', { email: t.mustacheVar('email') }
    t.mustacheBlock 'knownEmailProvider', ->
      t.li '.header-banner-link-left', ->
        t.a '.js-check-inbox', { href: '#' }, ->
          t.format 'check-your-inbox', { emailInboxUrl: t.mustacheVar('emailInboxUrl') }
      t.li '.header-banner-link-left.quiet', ->
        t.a '.js-resend-confirmation-email', { href: '#' }, ->
          t.format 'resend-email'
    t.mustacheBlockInverted 'knownEmailProvider', ->
      t.li '.header-banner-link-left.quiet', ->
        t.a '.js-resend-confirmation-email', { href: '#' }, ->
          t.format 'resend-email'
